module.exports = __webpack_public_path__ + "img/dongtai_banner.cd7438a1.png";